import { render, staticRenderFns } from "./HighlightsCardv2.vue?vue&type=template&id=670992d4&scoped=true"
import script from "./HighlightsCardv2.vue?vue&type=script&lang=js"
export * from "./HighlightsCardv2.vue?vue&type=script&lang=js"
import style0 from "./HighlightsCardv2.vue?vue&type=style&index=0&id=670992d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670992d4",
  null
  
)

export default component.exports